import { FEED_POST_DETAIL } from '@/constant/QueryKeyName';
import { routerToBack } from '@/helpers/checkRouterPrevPath';
import { delayCallback } from '@/helpers/delayNavigate';
import { EPostEvent, postMessagePostId } from '@/hooks/post/usePostManagement';
import { useScreen } from '@/hooks/useScreen';
import useToast from '@/hooks/useToast';
import { PATH_NAME } from 'configs/pathName';
import { PostContext } from 'context/PostContext';
import Button from 'design-system/components/Button/Button';
import { Typography } from 'design-system/components/Typography';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useContext, useState } from 'react';
import { useQueryClient } from 'react-query';

const Tooltips = dynamic(
  () => import('design-system/components/Tooltips/Tooltips')
);
const PostModal = dynamic(
  () => import('../../../../../modal/training-module/post/PostModal')
);
const ConfirmModal = dynamic(
  () => import('../../../../../modal/training-module/ConfirmModal')
);
const Popover = dynamic(() => import('@mui/material/Popover'));
const DropdownRow = dynamic(
  () => import('design-system/components/Dropdown/DropdownRow')
);

const PostControlMenuButton = () => {
  const { group, ...postInfo } = useContext(PostContext);
  const router = useRouter();
  const { pid: postId } = router.query;

  const { isDesktop } = useScreen();

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | undefined>(
    undefined
  );
  const openMenu = !!anchorEl;

  const [openEditModal, setOpenEditModal] = useState<boolean>(false);
  const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);

  const handleToggleEditPostModal = () => {
    setOpenEditModal((prev) => !prev);
  };

  const handleToggleConfirmDeleteModal = () => {
    setOpenConfirmDeleteModal((prev) => !prev);
  };

  const queryClient = useQueryClient();
  const toast = useToast();

  const handleDeletePost = async () => {
    try {
      await (
        await import('apis/tms/post.api').then((it) => it.deletePostHard)
      )(postInfo.postId);
      postMessagePostId(postInfo.postId, EPostEvent.Delete);
      toast('Xoá bài viết thành công', 'success');

      delayCallback(() => {
        queryClient.refetchQueries([FEED_POST_DETAIL, postInfo.postId], {
          active: true,
        });
        !!postId && routerToBack(router, PATH_NAME.HOME_FEED);
      }, 500);
    } catch (error) {
      toast('Xoá bài viết thất bại. Vui lòng thử lại', 'error');
    }
    handleToggleConfirmDeleteModal();
  };

  return (
    <>
      <Tooltips title={'Mở rộng'}>
        <Button
          size="medium"
          mode="icon-only"
          emphasis={isDesktop ? 'medium' : 'low'}
          icon={{
            name: 'more',
          }}
          onClick={(e) => setAnchorEl(e.currentTarget)}
        />
      </Tooltips>

      {openMenu && (
        <Popover
          open={openMenu}
          anchorEl={anchorEl}
          onClose={() => setAnchorEl(undefined)}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
        >
          {postInfo.isOwner && (
            <DropdownRow
              onClick={handleToggleEditPostModal}
              endIcon={{ name: 'edit' }}
            >
              <Typography variant="display3">Chỉnh sửa bài viết</Typography>
            </DropdownRow>
          )}
          <DropdownRow
            onClick={handleToggleConfirmDeleteModal}
            endIcon={{ name: 'trash' }}
          >
            <Typography variant="display3">Xoá bài viết</Typography>
          </DropdownRow>
        </Popover>
      )}

      {openEditModal && (
        <PostModal
          open={openEditModal}
          onClose={handleToggleEditPostModal}
          defaultData={{
            groupId: group?.groupId || 'null',
            content: postInfo.content,
            title: postInfo.title,
            hashtag: postInfo.hashTags.map((item) => ({
              name: item.name,
              value: item.id,
            })),
            postMode: postInfo.type,
            listImage: postInfo.images,
            postId: postInfo.postId,
            startDateTime: postInfo.startDate || '',
            endDateTime: postInfo.endDate || '',
            allowUploadedFile: postInfo.allowUploadedFile,
          }}
        />
      )}
      {openConfirmDeleteModal && (
        <ConfirmModal
          open={openConfirmDeleteModal}
          onClose={handleToggleConfirmDeleteModal}
          cancelCallback={handleDeletePost}
          confirmCallback={() => {}}
          title={'Xoá bài đăng'}
          description={'Bài đăng sẽ bị xoá vĩnh viễn. Bạn có muốn tiếp tục?'}
          confirmContent={'Huỷ'}
          cancelContent={'Xoá bài đăng'}
        />
      )}
    </>
  );
};
export default PostControlMenuButton;
